import { buildApiBaseUrl } from '../services/api';
import { getAccessToken } from '../services/clientSession';
import { AppLocale, resolveSupportedLocale } from './locales';

export type ServerLocaleSource = 'account' | 'accept-language' | 'default';

export interface ServerResolvedLocale {
  locale: AppLocale;
  source: ServerLocaleSource;
}

const isServerLocaleSource = (value: unknown): value is ServerLocaleSource => {
  return value === 'account' || value === 'accept-language' || value === 'default';
};

export const resolveLocaleFromServer = async (): Promise<ServerResolvedLocale | null> => {
  if (typeof fetch !== 'function') {
    return null;
  }

  const headers: Record<string, string> = {
    Accept: 'application/json',
  };

  const accessToken = typeof window !== 'undefined' ? getAccessToken() : null;
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  try {
    const response = await fetch(`${buildApiBaseUrl(process.env.REACT_APP_BFF_URL)}/i18n/resolve-locale`, {
      headers,
    });

    if (!response.ok) {
      return null;
    }

    const payload = await response.json() as { locale?: unknown; source?: unknown };
    if (typeof payload.locale !== 'string' || !isServerLocaleSource(payload.source)) {
      return null;
    }

    return {
      locale: resolveSupportedLocale(payload.locale),
      source: payload.source,
    };
  } catch {
    return null;
  }
};
